import Navbar from "../../Components/NavBar/index";
import Footer from "../../Components/Footer/index";
import BlogPostDetail from "../../Components/BlogPostDetail/index";

/**
 * BlogPost page wrapper.
 * SEO is handled INSIDE BlogPostDetail once the post data is loaded,
 * so we can set the correct dynamic title, description, and canonical URL
 * per individual post (critical for Google indexing).
 */
const BlogPost = () => {
    return (
        <>
            <Navbar />
            <div >
                <BlogPostDetail />
            </div>
            <Footer />
        </>
    );
};

export default BlogPost;
